import React, { useEffect } from 'react';
import AdvancedModal from '@portal/components/AdvancedModal/AdvancedModal';
import { translate } from '@portal/services/i18n';

import './OverdraftInfoModal.less';
import { useDispatch } from 'react-redux';
import { getOverdraftInfo } from '@portal/actions/account';
import useReduxState from '@portal/hooks/useReduxState';

interface OverdraftInfoProps {
  visible: boolean;
  onClose: () => void;
}

const OverdraftInfoModal: React.FC<OverdraftInfoProps> = ({
  visible,
  onClose,
}) => {
  const dispatch = useDispatch();

  const renderValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      (typeof value === 'number' && isNaN(value))
    ) {
      return translate('SHARED.NO_INFO');
    }

    return `${value}%`;
  };

  const {
    account: { overdraftInfo },
  } = useReduxState();

  useEffect(() => {
    if (visible && !overdraftInfo) {
      dispatch(getOverdraftInfo());
    }
  }, [visible, overdraftInfo, dispatch]);

  return (
    <AdvancedModal
      visible={visible}
      title={translate('COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.TITLE')}
      size="medium"
      onClose={onClose}
      actions={[
        {
          label: translate('SHARED.UNDERSTAND'),
          type: 'ok',
          onClick: onClose,
        },
      ]}
    >
      <div className="overdraft-info-modal">
        <div className="overdraft-info-modal__content">
          <h3 className="overdraft-info-modal__section-title">
            {translate(
              'COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.TAX_AND_INTEREST'
            )}
          </h3>

          <div className="overdraft-info-modal__item">
            <div className="overdraft-info-modal__item-row">
              <span className="overdraft-info-modal__label">
                {translate(
                  'COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.MONTHLY_EFFECTIVE'
                )}
              </span>
              <span className="overdraft-info-modal__value">
                {renderValue(overdraftInfo?.monthlyEffectiveAmount)}
              </span>
            </div>
          </div>

          <h4 className="overdraft-info-modal__subsection-title">
            {translate('COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.CET')}
          </h4>

          <div className="overdraft-info-modal__item">
            <div className="overdraft-info-modal__item-row">
              <span className="overdraft-info-modal__label">
                {translate('COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.MONTHLY')}
              </span>
              <span className="overdraft-info-modal__value">
                {renderValue(overdraftInfo?.cetMonthly)}
              </span>
            </div>
          </div>

          <div className="overdraft-info-modal__item">
            <div className="overdraft-info-modal__item-row">
              <span className="overdraft-info-modal__label">
                {translate('COMPONENTS.SIDEBAR_PROFILE.OVERDRAFT_INFO.ANNUAL')}
              </span>
              <span className="overdraft-info-modal__value">
                {renderValue(overdraftInfo?.cetAnually)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </AdvancedModal>
  );
};

export default OverdraftInfoModal;
